import { PlaceholdersId, TFComponent } from '@types';

import { IntegratorDataPlaceholder } from './integratorData';

export const integratorData: TFComponent = {
	component: IntegratorDataPlaceholder,
	id: PlaceholdersId.integratorData,
	name: 'integratorData',
};
